import { Check } from "lucide-react";

export const TemplateTile = ({ tpl, selected, onSelect }) => (
  <button
    onClick={() => onSelect(tpl.id)}
    className={`relative text-left card-surface card-hover p-5 overflow-hidden transition-all ${selected ? "ring-2 ring-primary" : ""}`}
    data-testid={`template-${tpl.id}`}
  >
    <span className="absolute inset-y-0 left-0 w-1.5" style={{ background: tpl.accent }} />
    <div className="flex items-start justify-between gap-2 pl-2">
      <div>
        <h3 className="text-lg font-semibold tracking-tight">{tpl.label}</h3>
        <p className="text-xs text-muted-foreground mt-1 leading-relaxed">{tpl.vibe}</p>
      </div>
      {selected && <span className="h-6 w-6 shrink-0 rounded-full bg-primary text-primary-foreground grid place-items-center"><Check size={13} strokeWidth={3} /></span>}
    </div>
    <span className="inline-block mt-3 ml-2 rounded-md bg-muted px-2 py-0.5 text-[10px] font-mono text-muted-foreground">{tpl.bpm} BPM</span>
  </button>
);
